<template>
    <div id="babyTicket">
        <div class="title">审核管理 > 亲子票务管理</div>
        <el-card class="main">
            <div class="query-form">
                <el-form :model="formInline" ref="ruleForm" label-width="82px">
                    <el-form-item label="景区名称：">
                        <el-input v-model="formInline.name" placeholder="请输入景区名称"></el-input>
                    </el-form-item>
                    <el-form-item label="景区状态：">
                        <el-select v-model="formInline.status" placeholder="请选择">
                            <el-option label="全部" :value="0"></el-option>
                            <el-option label="待审核/审核未通过" :value="1"></el-option>
                            <el-option label="暂停营业" :value="2"></el-option>
                            <el-option label="正在营业" :value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="店铺名称：">
                        <el-select v-model="formInline.shop_id" filterable placeholder="请选择">
                            <el-option label="全部" value="all"></el-option>
                            <el-option v-for="shop in shop_opt" :key="shop.shop_id" :label="shop.name" :value="shop.shop_id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="form-item-button" label-width="0">
                        <el-button @click="resetForm('ruleForm')">重置</el-button>
                        <el-button type="primary" @click="query">查询</el-button>
                        <el-button type="primary" @click="addAAA">新增</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
        <el-card class="table">
                <el-table :data="tableData" v-loading="loading" style="width: 100%; min-height: 450px;">
                    <el-table-column prop="name" label="景区名称"></el-table-column>
                    <el-table-column prop="open_times" label="营业时间"></el-table-column>
                    <el-table-column prop="min_price" label="起步价（元）"></el-table-column>
                    <el-table-column prop="start_tag" label="景区评分"></el-table-column>
                    <el-table-column prop="addr_i" label="景区地址"></el-table-column>
                    <el-table-column prop="view_status" label="景区状态">
                        <template slot-scope="{row}">
                            <span v-if="row.view_status == 0" class="status-view"> 
                                <span class="circle-status" style="background-color: #E6A23C;"></span>
                                待审核  
                            </span> 
                            <span v-if="row.view_status == 1" class="status-view"> 
                                <span class="circle-status" style="background-color: #67C23A;"></span>
                                审核中  
                            </span> 
                            <span v-if="row.view_status == 2" class="status-view"> 
                                <span class="circle-status" style="background-color: #F56C6C;"></span>
                                下架 
                             </span> 
                            <span v-if="row.view_status == 3" class="status-view"> 
                                <span class="circle-status" style="background-color: #67C23A;"></span>
                                上架 
                             </span> 
                            <span v-if="row.view_status == 4" class="status-view"> 
                                <span class="circle-status" style="background-color: #F56C6C;"></span>
                                未通过
                             </span>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="操作">
                        <template slot-scope="{row}" style="background:#f00">
                            <el-link 
                                type="primary" 
                                v-if="row.view_status == 1 || row.view_status == 3" 
                                @click="details(row)"
                            >
                                详情
                            </el-link>
                            <el-link type="primary" v-if="row.view_status == 0 || row.view_status ==2 || row.view_status == 4" @click="update(row)">编辑</el-link>
                            <el-link 
                                type="success" 
                                v-if="row.view_status == 2" 
                                @click="optionsState(row, 3)"
                            >
                                上架
                            </el-link>
                            <el-link 
                                type="danger" 
                                v-if="row.view_status == 3" 
                                @click="optionsState(row, 2)"
                            >
                                下架
                            </el-link>
                            <el-link 
                                type="warning" 
                                v-if="row.view_status == 0 || row.view_status == 4" 
                                @click="optionsState(row, 1)"
                            >
                                提交审核
                            </el-link>
                            <el-link 
                                type="primary" 
                                v-if="row.view_status == 4" 
                                @click="optionsState(row, 0)"
                            >
                                原因
                            </el-link>
                            <el-link 
                                type="danger" 
                                v-if="row.view_status == 0 || row.view_status == 2 || row.view_status == 4" 
                                @click="optionsState(row, 5)"
                            >
                                删除
                            </el-link>
                            <el-link 
                                type="danger" 
                                v-if="row.view_status == 1" 
                                @click="optionsState(row, 4)"
                            >
                                撤销审核
                            </el-link>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="table-footer">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[10, 20, 30, 40]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                    </el-pagination>
                </div>
        </el-card>
        <el-dialog
            title="提示"
            :visible.sync="soldOutDialog"
            width="30%">
            <p>下架该景区，是否继续？</p>
            <span slot="footer" class="dialog-footer">
                <el-button @click="soldOutDialog = false">取 消</el-button>
                <el-button type="primary" @click="onClickDialogSureBtn(2)">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="提示"
            :visible.sync="putawayDialog"
            width="30%">
            <p>上架该景区，是否继续？</p>
            <span slot="footer" class="dialog-footer">
                <el-button @click="putawayDialog = false">取 消</el-button>
                <el-button type="primary" @click="onClickDialogSureBtn(3)">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="提示"
            :visible.sync="checkDialog"
            width="30%">
            <p>提交审核，是否继续？</p>
            <span slot="footer" class="dialog-footer">
                <el-button @click="checkDialog = false">取 消</el-button>
                <el-button type="primary" @click="onClickDialogSureBtn(1)">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="提示"
            :visible.sync="cancelCheckDialog"
            width="30%">
            <p>撤销审核，是否继续？</p>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelCheckDialog = false">取 消</el-button>
                <el-button type="primary" @click="onClickDialogSureBtn(4)">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="审核失败"
            :visible.sync="failDialog"
            width="30%">
            <p>{{ failreason }}</p>
        </el-dialog>
        <el-dialog
            title="提示"
            :visible.sync="deleteDialog"
            width="30%">
            <p>删除该景区，是否继续？</p>
            <span slot="footer" class="dialog-footer">
                <el-button @click="deleteDialog = false">取 消</el-button>
                <el-button type="primary" @click="onClickDialogSureBtn(5)">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getArea, setState } from '@/api/baby/ticket.js';
import { getShopStorage } from '@/utils/storage.js'
export default {
    data () {
        return {
            loading: false,
            formInline: {
                name: '',
                status: 0,
                shop_id: 'all'
            },
            data: [],
            currentPage: 1,
            pageSize: 10,
            total: 0,
            check: 1,
            whyFail: '',
            failDialog: false,
            soldOutDialog: false,
            putawayDialog: false,
            deleteDialog: false,
            failreason: '',
            options: 0,
            row: {},
            checkDialog: false,
            cancelCheckDialog: false,
            shop_opt: []
        }
    }, 
    computed: {
        tableData () {
            return this.data
        }
    },
    methods: {
        handleSizeChange (page) {
            this.pageSize = page;
            this.initTable();
        },
        handleCurrentChange (page) {
            this.currentPage = page;
            this.initTable();
        },
        // 新增景区
        addAAA () {
            this.$router.push({path: '/home/baby-ticket-form', query: { operate: 'add' }})
        },
        // 编辑景区
        update (row) {
            let id = row.id, shop_id = row.shop_id;
            this.$router.push({path: '/home/baby-ticket-form', query: { id, shop_id, operate: 'update' }})
        },
        details (row) {
            let id = row.id, shop_id = row.shop_id;
            this.$router.push({path: '/home/baby-ticket-details', query: {id, shop_id, operate: 'details'}})
        },

        optionsState (row, options) {
            this.options = options;
            this.row = {...row};
            if (options == 0) {
                this.failreason = row.audit_refuse_reason;
                this.failDialog = true;
            }else if (options == 1) {
                this.checkDialog = true;
            } else if (options == 2) {
                this.soldOutDialog = true;
            } else if (options == 3) {
                this.putawayDialog = true;
            } else if (options == 4) {
                this.cancelCheckDialog = true;
            } else if (options == 5) {
                this.deleteDialog = true;
            }
        },

        // 弹框点击确定事件
        onClickDialogSureBtn (options) {
            let params = {
                id: this.row.id,
                shop_id: this.row.shop_id,
                options
            }
            setState(params)
                .then(res => {
                    if (res.data.code == 0) {
                        let text = '';
                        if (options == 1) {
                            text = '已提交审核！';
                        } else if (options == 2) {
                            text = '已暂停营业！'
                        } else if (options == 3) {
                            text = '已恢复营业！'
                        } else if (options == 4) {
                            text = '已撤销审核！'
                        } else if (options == 5) {
                            text = '已删除！'
                        }
                        this.$message.success(text);
                        this.initTable();
                    } else {
                        this.$message.error(res.data.msg);
                    }
                })
                .catch(err => {
                    this.$message.error(err.msg);
                })
                .finally(_ => {
                    this.checkDialog = false;
                    this.soldOutDialog = false;
                    this.putawayDialog = false;
                    this.cancelCheckDialog = false;
                    this.deleteDialog = false;
                })
        },
        // 原因
        cause (row) {
            this.failreason = row.audit_refuse_reason;
            this.failDialog = true;
        },
        // 重置查询表单
        resetForm(formName) {
            this.formInline.name = '';
            this.formInline.status = 0;
            this.formInline.shop_id = 'all';
            this.initTable();
            // this.$refs[formName].resetFields();
        },
        // 查询调用
        query () {
            this.initTable();
        },
        // 初始化表格数据，获取景区列表
        initTable () {
            let shop_ids = this.shop_opt.map(sp => { return sp.shop_id })
            let data = {
                shop_id: this.formInline.shop_id == 'all' ? shop_ids.join(',') : this.formInline.shop_id,   // 店铺id
                name: this.formInline.name,     // 查询景区名称
                status: this.formInline.status, // 查询景区状态
                page: this.currentPage,         // 当前页
                limit: this.pageSize            // 每页条数
            }
            this.loading = true;
            getArea(data)
                .then(res => {
                    if (res.data.code == 0) {
                        this.data = res.data.data.data;
                        this.total = res.data.data.total;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                })
                .catch(err => {
                    this.$message.error(err.msg);
                })
                .finally( _ => {
                    this.loading = false;
                })
        }
    },
    mounted () {
        if (getShopStorage()) {
            this.shop_opt = getShopStorage();
            this.initTable();
        } else {
            this.$confirm('您还没有自己的店铺哦，快去申请店铺吧！','提示',{
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                callback: action => {
                    if (action == 'confirm') {
                        this.$router.push({ path: "/home/shopManage" });
                    }
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
    #babyTicket {
        min-width: 1260px;
        .title {
            box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
            width: 100%;
            background: #fff;
            padding: 15px 32px;
            display: flex;
            align-items: center;
            font-size: 18px;
            color: #000;
            p {
                font-size: 16px;
                color: #333;
                margin-left: 32px;

                span {
                    color: #e72f0d;
                    padding: 0 5px;
                }

                &:first-child {
                    font-size: 18px;
                    color: #333;
                    margin-left: 0;
                }

                &:nth-child(2) {
                    span {
                        color: #2448ff;
                    }
                }
            }
        }
        .main {
            margin: 24px 24px 12px;
            border-radius: 0;
        }
        .query-form {
            .el-form {
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
            }
        }
        .table {
            margin: 0px 24px 24px 24px;
        }
    }

    .table-footer {
        padding-right: 12px;
        display: flex;
        justify-content: flex-end;
    }

    ::v-deep .el-pagination {
        margin-top: 12px;
        display: inline-block;
    }

    ::v-deep .el-select {
        width: 100%;
    }

    ::v-deep .el-dialog__header {
        border-bottom: 1px solid #F1F1F1;
        font-weight: bold;
    }
    
    ::v-deep .el-dialog {
        border-radius: 10px;
        min-width: 580px;
    }

    ::v-deep .el-dialog__footer {
        border-top: 1px solid #F1F1F1;
        padding: 10px 20px 10px;
    }

    ::v-deep .el-dialog__body {
        padding: 60px 80px;
    }

    ::v-deep .el-table__fixed-right {
        .el-table__cell {
            
            .el-link {
                &:not(:first-child) {
                    margin-left: 12px;
                }
            }
        }
    }

    .cell {
        .status-view {
            display: flex;
            align-items: center;
            .circle-status {
                display: block;
                width: 15px;
                height: 15px;
                border-radius: 10px;
                margin-right: 10px;
            }
        }
    }

    ::v-deep .form-item-button {
        .el-form-item__content {
            min-width: 240px;
        }
    }
    
    ::v-deep .el-form-item {
        flex: 1;
        &:not(:first-child) {
            margin-left: 24px;
        }
    }
    
</style>